import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftService } from '../../shift.service';
@Component({
  selector: 'app-driver-shift',
  templateUrl: './driver-shift.component.html',
  styleUrls: ['./driver-shift.component.scss']
})
export class DriverShiftComponent implements OnInit {
  shiftDetail: any = []; 
  did: number;
  id: string;
  public href = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shiftServices: ShiftService
  ) { }

  ngOnInit() {
    this.href = this.router.url;
    this.id = this.href.split('/')[3];
    // tslint:disable-next-line: radix
    this.did = parseInt(this.id);
    this.getShiftDetail();
  }
  getShiftDetail() {
    this.shiftServices.getDriverByShiftId(this.did).subscribe(Response => {
      this.shiftDetail = Response;
    });
  }
  gotoDriverinfo (id) {
    this.router.navigateByUrl('/drivers/driverinfo/' + id + '/profile');
  }
}
